import { actionNameGenerator } from "../../../../utils/commonUtil";

const domainPrefix = "ca";
const caActionNameGenerator = actionNameGenerator(domainPrefix);

export const fetchCADataType = caActionNameGenerator("fetchCAData");

export const updateFilterDataType = caActionNameGenerator("updateFilterData");

export const fetchDataByIdType = caActionNameGenerator("fetchDataById");

export const clearContributionType = caActionNameGenerator("clearContribution");

export const cancelContributionType = caActionNameGenerator("cancelContribution");

export const viewContributionType = caActionNameGenerator("viewContribution");

export const fetchCADataSuccessType = caActionNameGenerator("fetchCADataSuccess");

export const fetchCADrupalType = caActionNameGenerator("fetchCADrupal");

export const fetchDropdownDataType = caActionNameGenerator("fetchDropdownData");

export const fetchCADataByIdSuccessType = caActionNameGenerator("fetchCADataByIdSuccess");

export const fetchCADrupalWireType = caActionNameGenerator("fetchCADrupalWire");

export const fetchDataFailureType = caActionNameGenerator("fetchDataFailure");

export const fetchCWholeADataSuccessType = caActionNameGenerator("fetchCWholeADataSuccess");

export const replaceWithWholeDataType = caActionNameGenerator("replaceWithWholeData");

export const resetContributionType = caActionNameGenerator("resetContribution");

export const cancelOneContributionType = caActionNameGenerator("cancelOneContribution");